export default __webpack_public_path__ + "static/media/proximanova-bold.c43519e2.otf";